import { cx } from '@emotion/css';
import { Button } from '@mui/material';
import React from 'react';
import { ix } from '../../../../utils/ix';
import { Typography } from '../../../electrons';
import { useStyles } from './FileInput.styles';
export function FileInput(props) {
    const classes = useStyles();
    const handleFileInput = (event) => {
        var _a, _b;
        props.onFileInput((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0]);
        event.target.value = '';
    };
    const handleClear = () => {
        props.onClear && props.onClear();
    };
    return (React.createElement("div", { className: cx(props.className, classes.root), id: props.id },
        React.createElement(Button, { component: "label", variant: "contained", className: classes.inputButton, id: ix(props.id, 'input-button') },
            React.createElement(Typography, { variant: "body3", className: classes.buttonText, id: ix(props.id, 'input-text') }, props.inputButtonText || 'Choose File'),
            React.createElement("input", { type: "file", accept: props.accept, hidden: true, onChange: handleFileInput, id: ix(props.id, 'native-file-input'), className: classes.nativeInputButton })),
        props.fileName && (React.createElement(Typography, { variant: "body2", className: classes.fileName, id: ix(props.id, 'file-name') }, props.fileName)),
        props.clearable && props.fileName ? (React.createElement("div", { className: classes.clear, onClick: handleClear, id: ix(props.id, 'clear') },
            React.createElement(Typography, { className: classes.clearText, id: ix(props.id, 'clear-text') }, "Clear"))) : null));
}
export default FileInput;
//# sourceMappingURL=FileInput.js.map